var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTinnitumetria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.1,
    height: 68.1,
    viewBox: "0 0 68.1 68.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_717",
    "data-name": "Trazado 717",
    d: "M30.785,15.259,20.506,24.167l-2.89-4.886a2.975,2.975,0,0,0-4.648-.6L1.913,29.59a3,3,0,0,0,0,4.2,2.907,2.907,0,0,0,2.116.894,2.982,2.982,0,0,0,2.086-.864L14.427,25.6l2.741,4.678a2.992,2.992,0,0,0,4.529.745L34.689,19.758a2.975,2.975,0,0,0,.3-4.2,2.933,2.933,0,0,0-2.238-1.027,3.012,3.012,0,0,0-1.963.729M14.159.51,1.318,9.18a2.976,2.976,0,0,0-.8,4.141,2.938,2.938,0,0,0,2.473,1.311v.03a2.884,2.884,0,0,0,1.669-.507L14.338,7.6l1.847,5.1a2.959,2.959,0,0,0,4.291,1.549l14.838-8.67A2.985,2.985,0,0,0,32.3.42L20.565,7.3,18.629,1.97A2.993,2.993,0,0,0,16.752.153,2.829,2.829,0,0,0,15.829,0a2.988,2.988,0,0,0-1.669.51",
    transform: "translate(0 0)",
    fill: "#02ceff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1369",
    "data-name": "Grupo 1369",
    transform: "translate(-4427.595 -6188.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975",
    transform: "translate(4427.595 6188.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.1,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.1,
    rx: 13.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1005",
    "data-name": "Grupo 1005",
    transform: "translate(4443.246 6205.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_991",
    "data-name": "Grupo 991",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1751",
    "data-name": "Rect\\xE1ngulo 1751",
    width: 51.429,
    height: 51.429,
    transform: "translate(-17.961 17.136) rotate(-45)",
    fill: "#02ceff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTinnitumetria);
export default __webpack_public_path__ + "static/media/ic_tinnitumetria.1234d278aa12020d084513d75e8178f3.svg";
export { ForwardRef as ReactComponent };